/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable no-confusing-arrow */
import React, {
  useEffect,
  useState,
  Suspense,
  lazy,
} from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { PageParams } from 'constants/interfaces/GlobalInterfaces';
import styled from 'styled-components';
import SecondaryHeading from 'modules/Common/Components/SecondaryHeading';
import ViewSwitcherComponent from 'modules/Common/Components/ViewSwitcherComponent';
import {
  Col, Empty, Row, message,
} from 'antd';
import ToggleFilterButtonGlobal from 'modules/Common/Components/ToggleFilterButtonGlobal';
import ContactCardGlobal from 'modules/Common/Components/ContactCardGlobal';
import InfiniteScroll from 'react-infinite-scroll-component';
import classNames from 'classnames';
import {
  maxTablet, maxWidth, midMobile, retina,
} from 'constants/utilsStyles';
import SkeletonCustom from 'modules/Common/Skeleton/SkeletonCustom';
import ContactCardSkeleton from 'modules/Common/Skeleton/ContactCardSkeleton';
import ConfirmDialog from 'modules/Common/Components/ConfirmDialog';
import {
  addGillRoyIconWhenAudienceSelected,
  getQueryListId, getQueryParam,
  removeGillRoyIconWhenAudienceSelected,
} from 'utils';
import { TAB_AUDIENCE } from 'constants/paths';
import AudienceContacts from 'modules/Audience/Page/AudienceContacts';
import {
  getAudienceListContactsAction,
  deleteListContactsAction,
  removeListContactAction,
  resetListContactsDataAction,
  resetSearchedListContactsAction,
  reloadListDetailsContactsAction,
  removeSearchTermOnly,
} from '../Actions/listDetailsActions';
import { IContactItem, FooterActionsEnum } from '../interface';
import {
  listContactsFiltersApplyAction,
  listContactsResetFiltersAction,
  globalContactsFiltersApplyAction,
  globalContactsResetFiltersAction,
  loadListDesignationsAction,
  loadListOrganizationsAction,
} from '../Actions/contactsFiltersActions';
import {
  resetGlobalContactsSearchedAction,
  removeFromListContactsAction,
  updateCurrentActiveList,
} from '../Actions/globalContanctsActions';
import ContactsTileTable from '../Components/TableForTileView/ContactsTileTable';
import { ISortConfig, ISortOrder } from '../interfaces2';

const ContactsFooterWrapper = lazy(() => import('modules/Audience/Components/Footer/ContactsFooter'));

interface WrapperProps {
  addToListMode?: boolean;
}

const Wrapper = styled.div<WrapperProps>`
&.sub-container {
  &.mainContainer {
    &.shortHeight {
      height: 100% !important;
    }
    &.fullHeight {
      height: 100% !important;
    }
  }
}
&.shortHeight {
  .contacts-tile-table-wrapper {
    .aud-Infinite-scroll {
      overflow-y: auto;
      overflow-x: hidden !important;
    }
  }
}
&.tableViewMainContainer {
    .contacts-tile-table-wrapper {
      .aud-Infinite-scroll {
        overflow-y: auto;
        overflow-x: hidden !important;
        .ant-table-wrapper {
          .ant-table {
            .ant-table-container {
              .ant-table-body {
                /* height: calc(100vh - 362px) !important; */
                height: ${(props) => props.addToListMode ? 'calc(70vh - 362px) !important' : 'calc(100vh - 362px) !important'};
                overflow-y: auto;
                overflow: auto !important;
                overflow-x: hidden !important;
                @media all and (max-width: ${maxWidth}), ${retina} {
                 /* height: calc(100vh - 295px) !important; */
                 height: ${(props) => props.addToListMode ? 'calc(75vh - 295px) !important' : 'calc(100vh - 295px) !important'};
                }
              }
            }
          }
        }
      }
    }
  }
  margin: 15px 0 20px 0;
  @media all and (max-width: ${maxWidth}), ${retina} {
    margin: 10px 0 10px 0;
  }
  .heading-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-right: 25px;
    min-height: 37px;
    @media all and (max-width: ${maxTablet}) {
      position: relative;
    }
    .heading-filter-div {
      display: flex;
      align-items: center;
      width: calc(100% - 110px);
      @media all and (max-width: ${maxWidth}), ${retina} {
        width: calc(100% - 100px);
      }
      .secondary-heading {
        max-width: 17%;
        @media all and (max-width: ${maxTablet}) {
          max-width: 100%;
        }
      }
      .toggle-filter-btn-global {
        max-width: 70%;
        margin-left: 10px;
        @media all and (max-width: ${maxTablet}) {
          max-width: 100%;
        }
      }
      @media all and (max-width: ${maxTablet}) {
        flex-direction: column;
        align-items: flex-start;
        .toggle-filter-btn-global {
          margin-top: 10px;
          margin-left: 0px;
          .filters-div {
            .drop-down-btn-global-wrapper {
              .right-separator {
                display: none;
              }
              svg {
                margin-left: 2px;
              }
            }
          }
        }
      }
    }
    .view-switch-cmp {
      margin-right: 15px;
      @media all and (max-width: ${maxTablet}) {
        margin-right: 6px;
        position: absolute;
        top: 0px;
        right: 10px;
      }
    }
  }
  .contacts-row {
    margin: 0;
    padding-top: 10px !important;
  }
  .aud-Infinite-scroll {
    .audience-module-row {
      height: 100%;
      @media all and ((min-width: ${maxTablet}) and (max-width: ${maxWidth})) , ${retina} {
        margin-left: -12px !important;
      }
    }
  }
  @media all and (max-width: ${midMobile}) {
    .heading-div{
      width: 100%;
      .heading-filter-div {
        width: 100%;
      }
    }
  }
`;

const DialogWrapper = styled.div`
  z-index: 17;
  top: 50%;
  left: 50%;
  position: fixed;
  .back-overlay {
    position: fixed;
    background: grey;
    opacity: 0.2;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
  }
`;

type Props = {
  page: string | undefined,
  listView: boolean,
  isDashboard?: boolean,
} & PageParams;

const AudienceListDetails = (props: Props) => {
  const listId = getQueryListId();
  const { page: pageName, listView, isDashboard } = props;
  const [isSearched, setIsSearched] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState<IContactItem[]>([]);
  const [selectedContactsIds, setSelectedContactsIds] = useState<number[]>([]);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [showFooter, setShowFooter] = useState<boolean>(false);
  const [firstRenderDone, setFirstRenderDone] = useState(false);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  // const [removeContact, setContactRemove] = useState<boolean>(false);
  const [footerActionType, setFooterActionType] = useState<string>('');
  const [holdSelectedIds, setHoldSelectedIds] = useState<number[]>([]);
  const [localSearchTerm, setLocalSearchTerm] = useState('');
  const [addToListMode, setAddToListMode] = useState<boolean>(false);

  // eslint-disable-next-line
  const {
    loading,
    searchedLoading,
    page,
    searchedPage,
    searchTerm,
    listContacts,
    searchedlistContacts,
    totalContacts,
    totalSearchedContacts,
    listName,
    listId: listIdFromStore,
    reloadListContacts,
  } = useSelector((state: RootState) => state.audienceListDetailsReducerV2);
  const {
    designation: listDesignationSelected,
    organization: listOrganizationSelected,
    personalityType: listPersonalitySelected,
    status: listStatusSelected,
  } = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.selectedFilters);
  const activeList = useSelector((state: RootState) => state.globalContacts.currentActiveList);

  const queryListId = getQueryListId();
  const isSeeAll = getQueryParam('see_all') === 'true';

  const SORT_ORDER_DEFAULT = {
    name: null,
    company: null,
    personality: null,
    status: null,
    engagement: null,
  };

  const listContactsFiltersOrganizations = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters.organization);
  const listContactsFiltersDesignations = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters.designation);
  const listContactsFiltersPersonality = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters.personalityType);
  const listContactsFilterStatus = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters.status);
  const selectedListFilter = useSelector((state: RootState) => state.contactsFilters.listContactsFilters.appliedFilters);
  const newContactAdded = useSelector((state: RootState) => state.globalContacts.newContactAdded);
  const filterApplied = selectedListFilter.designation.length > 0 || selectedListFilter.status.length > 0
    || selectedListFilter.organization.length > 0 || selectedListFilter.personalityType.length > 0;

  const clearSelection = () => {
    setSelectedContacts([]);
    setSelectedContactsIds([]);
    setHoldSelectedIds([]);
    setSelectAll(false);
    setShowFooter(false);
  };

  const filtersApplied = listContactsFiltersOrganizations.length > 0
    || listContactsFiltersDesignations.length > 0
    || listContactsFiltersPersonality.length > 0
    || listContactsFilterStatus.length > 0;

  // State for updating sorting order of table columns
  const [sortOrder, setSortOrder] = useState<ISortOrder>(SORT_ORDER_DEFAULT);

  const [sortConfig, setSortConfig] = useState<ISortConfig>({
    // or any initial sorting direction
    sortBy: '',
    // or 'company', 'personality', 'status', 'engagement', etc.
    sortType: '',
  });

  // Updating next sorting order for table header
  function getNextSortingOrder(currentOrder: string | null) {
    if (!currentOrder) return 'ascend';
    if (currentOrder === 'ascend') return 'descend';
    return null;
  }

  // Updating state of sorting order for updating sort icon on table header
  const updateSortingOrders = (property: keyof ISortOrder) => {
    setSortOrder((prevSortOrder) => ({
      ...SORT_ORDER_DEFAULT,
      [property]: getNextSortingOrder(prevSortOrder[property]),
    }));
  };

  //  Update the sort type (ascending or descending) and sort by(name,company)
  const updateSortingConfig = (sortContactBy: string, sortContactType: string) => {
    setSortConfig((prevConfig) => ({
      ...prevConfig,
      sortBy: sortContactBy,
      sortType: sortContactType,
    }));
  };

  const getOffset = (listsLength: number, pageNumber: number) => {
    console.log(pageNumber);
    if (searchTerm !== '' && searchedPage === 0) {
      return 0;
    }
    return listsLength > 0 ? listsLength : 0;
  };

  const getParams = (listsLength: number, pageNumber: number, useSearchTerm?: string) => {
    const limit = 20;
    const offset = getOffset(listsLength, pageNumber);
    // const searchByName = '';
    const { sortBy, sortType } = sortConfig;
    const filterByOrganization = listContactsFiltersOrganizations;
    const filterByDesignation = listContactsFiltersDesignations;
    const filterByPersonalityType = listContactsFiltersPersonality;
    const filterByStatus = listContactsFilterStatus;

    return {
      limit,
      offset,
      search_term: useSearchTerm || (isSearched ? searchTerm : ''),
      sort_by: sortBy,
      sort_type: sortType,
      filter_by_organization: filterByOrganization,
      filter_by_designation: filterByDesignation,
      filter_by_personality_type: filterByPersonalityType,
      filter_by_status: filterByStatus,
    };
  };

  const getDeleteParams = () => {
    const excludedContactIds = selectAll ? selectedContactsIds : [];
    // const idOfList = listId ?? '';
    return {
      listId,
      contactIds: selectedContactsIds,
      deleteAll: selectAll,
      excludedContactIds,
      searchTerm,
      selectedOrganization: listContactsFiltersOrganizations,
      selectedDesignation: listContactsFiltersDesignations,
      selectedPersonalityType: listContactsFiltersPersonality,
      selectedStatus: listContactsFilterStatus,
    };
  };

  const handleActiveList = () => {
    if (selectedContactsIds.length > 0 || selectAll) {
      updateCurrentActiveList('list');
    } else if (activeList !== 'global_list') {
      // if currentActive list is global and user change search, it shouldn't reset the currentActive to default.
      // Only reset if current list is "global" and search changes.
      updateCurrentActiveList('');
    }
  };

  const handleResetSelectedContacts = () => {
    setShowFooter(false);
    setSelectedContacts([]);
    setSelectedContactsIds([]);
    setSelectAll(false);
  };

  const handleSelectAll = (flag: boolean) => {
    if (!flag && selectAll) {
      handleResetSelectedContacts();
    } else {
      setSelectAll(flag);
      setSelectedContacts([]);
      setSelectedContactsIds([]);
      setShowFooter(true);
    }
  };

  const isSearchedList = () => {
    if (isSearched) {
      return searchedlistContacts;
    }
    return listContacts;
  };

  const loadMore = () => {
    if (isSearched ? !searchedLoading : !loading) {
      if (isSearched) {
        getAudienceListContactsAction(getParams(searchedlistContacts.length, searchedPage));
      } else {
        getAudienceListContactsAction(getParams(listContacts.length, page));
      }
    }
  };

  const handleSelectContacts = (contact: IContactItem, type?: string) => {
    if (selectedContactsIds.includes(contact.contactId)) {
      const contacts = [...selectedContacts].filter((item) => item.contactId !== contact.contactId).map((item) => item);
      const contactIds = [...selectedContactsIds].filter((item) => item !== contact.contactId).map((item) => item);
      if (contactIds.length > 0) {
        setShowFooter(true);
      } else if (!selectAll) {
        setShowFooter(false);
      }
      setSelectedContacts(contacts);
      setSelectedContactsIds(contactIds);
      if (!selectAll) {
        setHoldSelectedIds(contactIds);
      }
    } else {
      setSelectedContacts((prevContacts) => ([contact, ...prevContacts]));
      setSelectedContactsIds((prevContactIds) => [contact.contactId, ...prevContactIds]);
      if (selectAll) {
        const removeFromSelectedIds = holdSelectedIds.filter((id) => contact.contactId !== id);
        setHoldSelectedIds(removeFromSelectedIds);
      } else {
        setHoldSelectedIds([contact.contactId, ...selectedContactsIds]);
      }
      if (!showFooter) {
        if (type !== FooterActionsEnum.REMOVE_FROM_LIST) setShowFooter(true);
      }
    }
  };

  const handleHoldSelectedIds = (ids: number[], removeExcludedIds?: boolean) => {
    if (removeExcludedIds) {
      const contactIds = ids.filter((id) => !selectedContactsIds.includes(id));
      setHoldSelectedIds(contactIds);
    } else {
      setHoldSelectedIds(ids);
    }
  };

  const handleConfirmDeleteContact = () => {
    deleteListContactsAction(getDeleteParams())
      .then(() => {
        setShowConfirmation(false);
        // Success Taoster
        // eslint-disable-next-line
        message.success({
          content: 'Contact has been deleted successfully.',
        });
      })
      .catch((err) => {
        setShowConfirmation(false);
        // Error Taoster
        // eslint-disable-next-line
        message.error({
          content: 'Unable to delete Contact. Please try again later or contact support at support@xiqinc.com.',
        });
        console.log(err);
      });
    clearSelection();
  };

  const handleConfirmRemoveContact = () => {
    removeListContactAction(getDeleteParams())
      .then(() => {
        removeFromListContactsAction(getDeleteParams());
        setShowConfirmation(false);
        // Success Taoster
        // eslint-disable-next-line
        message.success({
          content: 'Contact(s) removed successfully.',
        });
        clearSelection();
        updateCurrentActiveList('');
      })
      .catch((err) => {
        setShowConfirmation(false);
        // Error Taoster
        // eslint-disable-next-line
        message.error({
          content: 'Unable to remove Contact. Please try again later or contact support at support@xiqinc.com.',
        });
        clearSelection();
        updateCurrentActiveList('');
        console.log(err);
      });
  };

  const handleShowConfirmationDialog = (type: string) => {
    setFooterActionType(type);
    setShowConfirmation(true);
  };

  const handleCloseConfirmationDialog = () => {
    setShowConfirmation(false);
    setFooterActionType('');
    if (footerActionType === FooterActionsEnum.REMOVE_FROM_LIST) clearSelection();
  };

  const handleGetSelectedIds = () => {
    const excludedContactIds = selectAll ? selectedContactsIds : [];
    if (selectAll && excludedContactIds.length > 0) {
      // const selectedIds = holdSelectedIds.filter((id) => !selectedContactsIds.includes(id));
      return holdSelectedIds;
    }

    if (selectAll) {
      return holdSelectedIds;
    }

    return selectedContactsIds;
  };

  const getFooterCount = () => {
    if (selectAll) {
      return (isSearched ? totalSearchedContacts : totalContacts) - selectedContactsIds.length;
    }
    return selectedContactsIds.length;
  };

  const getMessageString = () => {
    if (footerActionType === FooterActionsEnum.REMOVE_CONTACT) {
      return 'Removing the selected contact(s) will remove them from the list and they will no longer receive any emails sent to this list.';
    }

    if (selectedContactsIds.length > 1 || selectAll) {
      // If more than one contact is selected or all contacts are selected.
      return `Selected contact(s) will be removed from the list (${listName}).`;
    }

    if (footerActionType === FooterActionsEnum.REMOVE_FROM_LIST) {
      return `Do you want to remove ${selectedContacts[0]?.contactName} from the list (${listName})?`;
    }

    return 'Deleting the selected contact(s) will permanently delete them from your Audience. Are you sure you want to proceed?';
  };

  const handleDisableSelectAll = () => {
    if (addToListMode) {
      // Disable selectAll if globalContactsNotInListCount is ZERO.
      return isSearched ? !totalSearchedContacts : !totalContacts;
    }

    return false;
  };

  const getConfirmationHandle = () => {
    if (footerActionType === FooterActionsEnum.REMOVE_CONTACT || footerActionType === FooterActionsEnum.REMOVE_FROM_LIST) {
      return { handle: handleConfirmRemoveContact, confirmationText: 'Confirm' };
    }
    return { handle: handleConfirmDeleteContact, confirmationText: 'Delete' };
  };

  const sortListContactsData = () => {
    if (searchTerm === '') {
      resetListContactsDataAction();
      getAudienceListContactsAction(getParams(0, 0));
    } else {
      resetListContactsDataAction();
      resetSearchedListContactsAction();
      getAudienceListContactsAction(getParams(0, 0, searchTerm));
    }
  };

  useEffect(() => {
    sortListContactsData();
  }, [sortOrder]);

  useEffect(() => {
    if (searchTerm !== '' && searchTerm !== localSearchTerm) {
      if (!isSearched) setIsSearched(true);
      setLocalSearchTerm(searchTerm);
      setAddToListMode(true);
      getAudienceListContactsAction(getParams(0, 0, searchTerm));
    } else if (searchTerm === '' && isSearched) {
      setLocalSearchTerm('');
      setIsSearched(false);
      resetListContactsDataAction();
      getAudienceListContactsAction(getParams(0, 0));
      setAddToListMode(false);
    }
    // Whenever the searchTerm changes, selection should clear.
    if (selectAll) {
      clearSelection();
    }
  }, [searchTerm]);

  const firstLoading = isSearched ? searchedLoading && searchedlistContacts.length === 0
    : loading && listContacts.length === 0;

  const loadingContacts = isSearched ? searchedLoading : loading;

  const handleClearFilters = () => {
    clearSelection();
    listContactsResetFiltersAction();
    if (isSearched) {
      listContactsResetFiltersAction();
      globalContactsResetFiltersAction();
    } else {
      listContactsResetFiltersAction();
    }
  };

  useEffect(() => {
    setFirstRenderDone(true);
    if (queryListId?.toString() !== listIdFromStore?.toString()) {
      if (isSearched) {
        resetSearchedListContactsAction();
      } else {
        resetListContactsDataAction();
      }
      getAudienceListContactsAction(getParams(0, 0));
    }

    if (pageName === 'view') {
      // Gets List's Organizations and Designations on See All
      loadListOrganizationsAction(queryListId?.toString());
      loadListDesignationsAction(queryListId?.toString());
    }
    return () => {
      handleClearFilters();
      removeSearchTermOnly();
      resetSearchedListContactsAction();
    };
  }, []);

  useEffect(() => {
    if (reloadListContacts) {
      if (isSearched) {
        resetSearchedListContactsAction();
      } else {
        resetListContactsDataAction();
      }
      getAudienceListContactsAction(getParams(0, 0));
      reloadListDetailsContactsAction(false);
    }
  }, [reloadListContacts]);

  const handleApplyFilters = () => {
    if (isSearched) {
      listContactsFiltersApplyAction();
      globalContactsFiltersApplyAction();
    } else {
      listContactsFiltersApplyAction();
    }
  };

  useEffect(() => {
    if (firstRenderDone) {
      // resetGlobalContactsAction();
      if (isSearched) {
        resetSearchedListContactsAction();
        if (!addToListMode) resetGlobalContactsSearchedAction();
      } else {
        resetListContactsDataAction();
      }
      getAudienceListContactsAction(getParams(0, 0));
    }
    // Whenever the filters changes, selection should clear.
    if (selectAll) {
      clearSelection();
    }
  }, [listContactsFiltersOrganizations, listContactsFiltersDesignations, listContactsFiltersPersonality, listContactsFilterStatus]);

  const totalAudience: number = isSearched ? totalSearchedContacts : totalContacts;

  useEffect(() => {
    if (selectedContactsIds.length === 0) {
      addGillRoyIconWhenAudienceSelected();
    } else {
      removeGillRoyIconWhenAudienceSelected();
    }

    handleActiveList();
  }, [selectedContactsIds]);

  return (
    <>
      <Wrapper
        addToListMode={addToListMode}
        className={classNames('sub-container', {
          mainContainer: !isDashboard,
          tableViewMainContainer: listView && pageName !== TAB_AUDIENCE.VIEW && !isDashboard,
          shortHeight: addToListMode,
        })}
      >
        {showConfirmation && (
          <DialogWrapper>
            <div className="back-overlay" />
            <ConfirmDialog
              cancel="Cancel"
              confirm={getConfirmationHandle().confirmationText}
              onConfirm={getConfirmationHandle().handle}
              onCancel={handleCloseConfirmationDialog}
              title={getMessageString()}
              titleQuestion={null}
            />
          </DialogWrapper>
        )}
        {firstLoading && !filtersApplied ? (
          <div className="heading-div">
            {[1, 2].map((item) => (
              <SkeletonCustom
                key={`list-contact-filter-skeleton-${item}`}
                height="30px"
                width="120px"
                diameter="8px"
                margin="0 0 0 10px"
              />
            ))}
          </div>
        ) : (
          <div className="heading-div">
            <div className="heading-filter-div">
              <SecondaryHeading title={`${listName}`} count={`(${totalAudience})`} />
              <ToggleFilterButtonGlobal
                onApplyFilters={handleApplyFilters}
                applied={filtersApplied}
                onClearFilters={handleClearFilters}
                fromList={true}
              />
            </div>
            <ViewSwitcherComponent goBackLink={isSeeAll ? '/audiences/lists' : '/audiences/'} viewSwitch={pageName === 'view'} redirectLink="contacts" />
          </div>
        )}
        {!listView ? (
          <InfiniteScroll
            dataLength={isSearched ? searchedlistContacts?.length : listContacts?.length}
            next={loadMore}
            hasMore={isSearched ? searchedlistContacts?.length < totalContacts : listContacts?.length < totalContacts}
            loader={false}
            height="auto"
            className={classNames('aud-Infinite-scroll')}
          >
            <Row gutter={[24, listView ? 8 : 8]} className="audience-module-row contacts-row">
              {[...(isSearched ? searchedlistContacts : listContacts)].map((contact, index) => (
                <Col span={listView ? 24 : 6} className={classNames('audience-module-col', { gridCol: !listView })}>
                  <ContactCardGlobal
                    handleSelectContacts={handleSelectContacts}
                    contact={contact}
                    listView={listView}
                    isSelected={handleGetSelectedIds().includes(contact.contactId)}
                    selectDisable={activeList === 'global_list'}
                    selectedCount={handleGetSelectedIds().length}
                    index={index}
                  />
                </Col>
              ))}
              {loadingContacts
                ? [1, 2, 3, 4, 5].map((item) => (
                  <Col span={listView ? 24 : 6} className={classNames('audience-module-col', { gridCol: !listView })}>
                    <ContactCardSkeleton key={`col-loader${item}`} listView={listView} />
                  </Col>
                )) : null}
              {[...(isDashboard ? listContacts : isSearchedList())].length === 0 && !loading
                ? (
                  <div className="no-data-found" style={{ width: '100%' }}>
                    <Empty description={`${isSearched || filterApplied ? 'No contact(s) found against your search' : 'Your contact(s) will show up here once you will import a list or create a new contact.'}`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </div>
                ) : null}
            </Row>
          </InfiniteScroll>
        ) : (
          <ContactsTileTable
            isSearched={isSearched}
            contacts={listContacts}
            loading={loading}
            searchedContacts={searchedlistContacts}
            totalContacts={totalContacts}
            selectAll={selectAll}
            sortOrder={sortOrder}
            updateSortingOrders={updateSortingOrders}
            updateSortingConfig={updateSortingConfig}
            holdSelectedIds={holdSelectedIds}
            isDashboard={isDashboard}
            searchLoading={searchedLoading}
            totalSearchContacts={totalSearchedContacts}
            addToListMode={addToListMode}
            isListActive={activeList === 'global_list'}
            excludedContactsIds={selectedContactsIds}
            disableSelectAll={handleDisableSelectAll()}
            loadMore={loadMore}
            handleSelectContacts={handleSelectContacts}
            handleSelectAll={handleSelectAll}
            handleHoldSelectedIds={handleHoldSelectedIds}
            handleConfirmation={handleShowConfirmationDialog}
            newContactAdded={newContactAdded}
          // updateContactSuccess={updateContactSuccess}
          />
        )}
      </Wrapper>
      {localSearchTerm !== '' && <AudienceContacts page="contacts" isGlobal listView={listView} addToListMode={addToListMode} />}
      <Suspense fallback={<></>}>
        <ContactsFooterWrapper
          toggle={showFooter}
          list={false}
          listId={listIdFromStore}
          inList={true}
          count={getFooterCount()}
          clearSelection={clearSelection}
          showAddToList
          showRemoveFromList={isSearched}
          handleConfirmation={handleShowConfirmationDialog}
          showRemove={!addToListMode}
          addToListMode={addToListMode}
          selectedCount={selectAll ? holdSelectedIds.length - selectedContactsIds.length : holdSelectedIds.length}
          selectedOrganization={listOrganizationSelected}
          selectedDesignation={listDesignationSelected}
          selectedPersonality={listPersonalitySelected}
          selectedStatus={listStatusSelected}
          selectedContactsIds={selectedContactsIds}
          selectedContacts={selectedContacts}
        />
      </Suspense>
    </>
  );
};

AudienceListDetails.defaultProps = {
  isDashboard: false,
};
export default AudienceListDetails;
